/**
 * Общий Symbol для отслеживания глубины вложенности ClientOnlyRouterView
 * Используется через inject/provide для передачи depth между уровнями
 * 
 * ВАЖНО: Symbol должен быть один на все компоненты, поэтому он вынесен в отдельный файл
 */
export const ROUTER_VIEW_DEPTH_KEY = Symbol('routerViewDepth');
